import React, { useEffect, useContext,useState } from "react";
import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";
import { motion } from "framer-motion";
import "./investorpage.css";

const InvestorPage = () => {
  

  const [expanded, setExpanded] = useState(null);

  const toggleCard = (id) => {
    setExpanded(prev => (prev === id ? null : id));
  };

  const COLORS = ["#A70002", "#FFBB28", "#00C49F"];
  const pieData = [
    { name: "商業模式", value: 35 },
    { name: "成長潛力", value: 40 },
    { name: "回報方式", value: 25 },
  ];

  const barData = [
    { name: "AI 建設", value: 30 },
    { name: "券商整合", value: 25 },
    { name: "品牌行銷", value: 20 },
    { name: "法遵風控", value: 15 },
    { name: "營運資金", value: 10 },
  ];

  const timelineData = [
    { time: "2024 Q3", event: "API 完成、進駐亞灣園區" },
    { time: "2024 Q4", event: "AI 助理測試、前端整合" },
    { time: "2025 Q1", event: "beta 上線、啟動招募" },
    { time: "2025 Q2", event: "正式商轉、擴大券商串接" },
  ];

  return (
    <div className="container-fluid px-0 investor-page gradient-bg">
      <div className="hero-banner d-flex align-items-center justify-content-center text-white">
        <div className="text-center">
          <h1 className="display-4 fw-bold">💼 投資順星</h1>
          <p className="lead">一起打造下一代 AI 金融基礎設施</p>
          <a href="#contact" className="btn btn-danger px-4 py-2 mt-2">立即聯絡我們</a>
        </div>
      </div>

      <div className="container py-5">

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="mb-5">
          <h4 className="fw-bold mb-3">🚀 公司願景</h4>
          <p>
            建立一個讓所有投資人（非專業投資人、全職交易者、金融組織）都能使用的程式交易 AI 平台，
            解決技術門檻高與資訊斷層問題，提供簡單、可視化的交易決策工具。
          </p>
          <hr />
        </motion.div>

        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1 }} className="mb-5">
          <h4 className="fw-bold mb-3">📊 投資人最關心的三件事</h4>
          <div style={{ width: "100%", height: 250 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={40}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  label
                  isAnimationActive={true}
                >
                  {pieData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <hr />
        </motion.div>

        <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} className="mb-5">
          <h4 className="fw-bold mb-3">🧠 MAS AI 平台技術特色</h4>
          <ul className="list-unstyled">
            <li>✅ AI 助理：自然語言 → 生成程式交易策略</li>
            <li>✅ 多券商整合：連接主流平台（MT5、REST API）</li>
            <li>✅ 實盤與模擬切換一致</li>
            <li>✅ 策略自動優化與大數據回測</li>
          </ul>
          <hr />
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 50 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} className="mb-5">
          <h4 className="fw-bold mb-3">💰 募資用途視覺化</h4>
          <div style={{ width: "100%", height: 300 }}>
            <ResponsiveContainer>
              <BarChart data={barData} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#A70002" radius={[4, 4, 0, 0]} isAnimationActive={true} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <hr />
        </motion.div>

        <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }} className="mb-5">
          <h4 className="fw-bold mb-3">🗓️ 發展時程與藍圖</h4>

          <div className="timeline-vertical">
            <div className="timeline-block done">
              <div className="timeline-content">
                <h6>草創初期</h6>
                <p>✅ 啟動資金 350 萬完成<br/>✅ 技術、行銷、業務團隊建置完成<br/>✅ 外部會計事務所簽約完畢<br/>✅ 公司成立</p>
                <div className="progress mt-3" style={{ height: "8px", background: "#e2e8f0" }}>
                  <div className="progress-bar" style={{ width: "100%", backgroundColor: "#10b981" }}></div>
                </div>
                <p className="text-end small text-success">完成度：100%</p>
              </div>
            </div>

            <div className="timeline-block doing">
              <div className="timeline-content">
                <h6>技術研發階段</h6>
                <p>✅ AI 回測系統與 API 平台完成<br/>✅ 整合 90% 券商 API<br/>✅ AI 交易助理模型完成<br/>🔄 前後端交易平台開發中<br/>🔄 MAS AI 進階版設計進行中</p>
                <div className="progress mt-3" style={{ height: "8px", background: "#e2e8f0" }}>
                  <div className="progress-bar" style={{ width: "60%", backgroundColor: "#facc15" }}></div>
                </div>
                <p className="text-end small text-warning">完成度：60%</p>
              </div>
            </div>

            <div className="timeline-block future">
              <div className="timeline-content">
                <h6>營運與市場拓展</h6>
                <p>
                ✅ 經濟部中小及新創企業署(亞灣新創園區) 完成進駐<br/>
                ✅ 中央經濟部產業園區(高雄軟體園區) 投資案審核通過<br/>
                ✅ 金融科技園區第一階段審核通過<br/>
                🔄 SBIR / CITD 計畫撰寫與送審中<br/>
                🔄 國內外券商與金融機構合作洽談中<br/>
                🔄 擴展全球訂閱用戶至 10,000 名以上<br/>
                🔭 持續參與政府創新研發計畫，強化技術研發能量<br/>
                🔭 推出次世代 AI 自動化交易助理，全面提升交易智能化<br/>
                🔭 預計三年內設立新加坡亞洲營運中心，佈局東南亞市場
                <br/>
                </p>
                <div className="progress mt-3" style={{ height: "8px", background: "#e2e8f0" }}>
                  <div className="progress-bar" style={{ width: "40%", backgroundColor: "#94a3b8" }}></div>
                </div>
                <p className="text-end small text-secondary">完成度：40%</p>
              </div>
            </div>
          </div>
          <hr />
        </motion.div>

        {/* 🔶 Roadmap 橫向時間軸區塊 */}
        <section className="mb-5">
          <h4 className="fw-bold mb-4">📍 Roadmap 年度藍圖</h4>
          <div className="d-flex flex-row flex-nowrap overflow-auto gap-4 roadmap-horizontal">
            <div className="p-3 bg-white border rounded shadow-sm min-w-[220px] text-center">
              <h6 className="text-primary">2024 Q3</h6>
              <p className="small">完成 API 開發<br/>進駐亞灣園區</p>
            </div>
            <div className="p-3 bg-white border rounded shadow-sm min-w-[220px] text-center">
              <h6 className="text-primary">2024 Q4</h6>
              <p className="small">AI 助理整合<br/>前端 UI/UX 設計</p>
            </div>
            <div className="p-3 bg-white border rounded shadow-sm min-w-[220px] text-center">
              <h6 className="text-primary">2025 Q1</h6>
              <p className="small">Beta 上線<br/>策略招募啟動</p>
            </div>
            <div className="p-3 bg-white border rounded shadow-sm min-w-[220px] text-center">
              <h6 className="text-primary">2025 Q2</h6>
              <p className="small">正式商轉<br/>擴大產品市佔率</p>
            </div>
            <div className="p-3 bg-white border rounded shadow-sm min-w-[220px] text-center">
              <h6 className="text-primary">2025 Q3</h6>
              <p className="small">洽談國際金融單位<br/>進入國際市場</p>
            </div>
            <div className="p-3 bg-white border rounded shadow-sm min-w-[220px] text-center">
              <h6 className="text-primary">2025 Q4</h6>
              <p className="small">子公司規劃<br/>新加坡據點前期布局</p>
            </div>
          </div>
        </section>


        <section className="container mb-5">
      <h4 className="fw-bold mb-4 text-center">📦 投資方案比較</h4>
      <div className="row g-4">
        {/* 方案 A */}
        <div className="col-md-4">
          <div className="card-invest">
            <div className="title">💰 方案 A</div>
            <div className="desc">適合小額投入者，享有穩定分潤與月度報告。</div>
            <div className="highlight">私募門檻：10 萬台幣起<br />分潤比例：年回報 5~8%</div>
            <div className="accordion-toggle" onClick={() => toggleCard("a")}>查看更多細節 <span>{expanded === "a" ? "▲" : "▼"}</span></div>
            <div className={`card-expandable ${expanded === "a" ? "open" : "closed"}`}>
              <p>可選擇每月或每季領息，享基本保本協議，並可升級至方案 B。</p>
            </div>
          </div>
        </div>

        {/* 方案 B */}
        <div className="col-md-4">
          <div className="card-invest">
            <div className="title">📈 方案 B</div>
            <div className="desc">中階投資人方案，支援 API 與策略測試。</div>
            <div className="highlight">門檻：30 萬起<br />回報：年化 10~15%</div>
            <div className="accordion-toggle" onClick={() => toggleCard("b")}>查看更多細節 <span>{expanded === "b" ? "▲" : "▼"}</span></div>
            <div className={`card-expandable ${expanded === "b" ? "open" : "closed"}`}>
              <p>提供測試 API 金鑰與策略回測模組，享每月平台 KPI 報表。</p>
            </div>
          </div>
        </div>

        {/* 方案 C */}
        <div className="col-md-4">
          <div className="card-invest">
            <div className="title">🤝 方案 C</div>
            <div className="desc">高資本夥伴方案，參與分潤共創計畫。</div>
            <div className="highlight">門檻：50 萬起<br />回報：20%+ 並享權益紅利</div>
            <div className="accordion-toggle" onClick={() => toggleCard("c")}>查看更多細節 <span>{expanded === "c" ? "▲" : "▼"}</span></div>
            <div className={`card-expandable ${expanded === "c" ? "open" : "closed"}`}>
              <p>成為 MAS 合作夥伴，享內部報表、年度收益權與策略研發分潤。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

        <div id="contact" className="text-center">
          <h5 className="fw-bold">📬 有興趣進一步了解？</h5>
          <p>立即來信聯絡我們或預約投資洽談。</p>
          <a href="mailto:mas@mindaismart.com" className="btn btn-outline-danger px-4 py-2 mt-2">
            📧 聯絡我們
          </a>
        </div>

      </div>
    </div>
  );
};

export default InvestorPage;
